import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "./useUser";

export const useSecurity = () => {
  const navigate = useNavigate();
  const { isLogged } = useUser();

  useEffect(() => {
    if (!isLogged) {
      navigate("/Identificarse");
    }
  }, []);
};
